import { Menu } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '../../../store';
import { getSpecialDateNameList, setFilter } from '../../../store/features/moments/momentsSlice';

export default function CustomizedMenus() {
    const { words } = useAppSelector(state => state.localization);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedValue, setSelectedValue] = useState<string>('');
    const { filter, specialDateNameList } = useAppSelector(state => state.moments);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getSpecialDateNameList());
    }, []);

    useEffect(() => {
        setSelectedValue(words && words['WEB.upcomingMoments']);
    }, [specialDateNameList?.loading]);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleTimeTypeChange = (timeType: number, name: string, valueHeader: string) => {
        setSelectedValue(valueHeader);
        dispatch(
            setFilter({
                ...filter,
                timeType: timeType ? timeType : 35,
            }),
        );
        setAnchorEl(null);
    };

    return (
        <>
            <Button aria-controls="customized-menu" id="coming-soon" aria-haspopup="true" onClick={handleClick} disableRipple className="select-03">
                <label className="select-label">{selectedValue}</label>
                <svg className="select-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </Button>
            <Menu id="select-03-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                {specialDateNameList?.items?.map((data, index) => {
                    return (
                        <MenuItem
                            key={'special-date-menu' + index}
                            onClick={() => handleTimeTypeChange(data.key, data.value, data.valueHeader)}
                            className="menu-item-list">
                            <ListItemText primary={data.value} />
                            {filter.timeType === data.key && (
                                <ListItemIcon>
                                    <svg
                                        className="menu-item-svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
                                            stroke="#00A3FF"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path d="M9 12L11 14L15 10" stroke="#00A3FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </ListItemIcon>
                            )}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
}
